export function deriveCloudSetupProgress({
  searchEnabled, searchVisible, onboarding = {}, wizardStatus,
}) {
  const legacySetupComplete = onboarding.completed === true;
  const integration = wizardStatus === 'completed' || legacySetupComplete;
  const connected = onboarding.catalogIndexed === true
    || onboarding.completed === true
    || onboarding.wizardCompleted === true;

  return {
    connected,
    integration,
    // A legacy shop can already have searchVisible=true before it completes
    // the new integration wizard. Activation is the last step, so only mark it
    // complete once its prerequisite integration is persisted as complete.
    activated: integration && (
      searchVisible === true || (legacySetupComplete && searchEnabled === true)
    ),
  };
}
